var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar_wrap"},[_c('div',{ref:"barcharts",staticClass:"barcharts",attrs:{"id":"barcharts"}})])}
var staticRenderFns = []

export { render, staticRenderFns }